import React from 'react'

const HomeIcon = ({color}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
    >
      <g clip-path='url(#clip0_1817_5533)'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M13.2281 2.68799C12.877 2.41488 12.4449 2.2666 12.0001 2.2666C11.5553 2.2666 11.1232 2.41488 10.7721 2.68799L2.3881 9.20799C1.6361 9.79499 2.0501 11 3.0031 11H4.0951L4.9151 19.199C4.96445 19.6925 5.19541 20.1501 5.56314 20.4829C5.93087 20.8157 6.40914 21 6.9051 21H17.0951C17.5911 21 18.0693 20.8157 18.4371 20.4829C18.8048 20.1501 19.0358 19.6925 19.0851 19.199L19.9051 11H20.9971C21.9491 11 22.3651 9.79499 21.6121 9.20899L13.2281 2.68799ZM5.9961 9.90999C5.9828 9.77716 5.94324 9.64829 5.87972 9.53087C5.81621 9.41345 5.73 9.30982 5.6261 9.22599L12.0001 4.26699L18.3741 9.22499C18.2702 9.30882 18.184 9.41245 18.1205 9.52987C18.057 9.64729 18.0174 9.77616 18.0041 9.90899L17.0951 19H6.9051L5.9961 9.90999ZM10.5001 13C10.5001 12.6022 10.6581 12.2206 10.9394 11.9393C11.2207 11.658 11.6023 11.5 12.0001 11.5C12.3979 11.5 12.7795 11.658 13.0608 11.9393C13.3421 12.2206 13.5001 12.6022 13.5001 13C13.5001 13.3978 13.3421 13.7793 13.0608 14.0606C12.7795 14.342 12.3979 14.5 12.0001 14.5C11.6023 14.5 11.2207 14.342 10.9394 14.0606C10.6581 13.7793 10.5001 13.3978 10.5001 13ZM12.0001 9.49999C11.0718 9.49999 10.1816 9.86874 9.52523 10.5251C8.86885 11.1815 8.5001 12.0717 8.5001 13C8.5001 13.9282 8.86885 14.8185 9.52523 15.4749C10.1816 16.1312 11.0718 16.5 12.0001 16.5C12.9284 16.5 13.8186 16.1312 14.475 15.4749C15.1314 14.8185 15.5001 13.9282 15.5001 13C15.5001 12.0717 15.1314 11.1815 14.475 10.5251C13.8186 9.86874 12.9284 9.49999 12.0001 9.49999Z'
          fill={color}
        />
      </g>
      <defs>
        <clipPath id='clip0_1817_5533'>
          <rect width='24' height='24' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}

export default HomeIcon
